function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`drawer-menu-open`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      document.body.classList.remove(`drawer-menu-open`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`drawer-menu-open`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      this.appendChild(content.querySelector("video, model-viewer, iframe")).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".slider") || this.querySelector("ul");
    this.sliderItems = this.slider
      ? this.slider.querySelectorAll(".slider__slide")
      : this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.isFeaturedProduct = this.hasAttribute("data-section-featured-product");
    this.parentSection = this.closest(".shopify-section");
    this.productForm = this.parentSection.querySelector("product-form");
  }

  onVariantChange(evt) {
    if (evt.target.id === "auto-delivery-info") return;

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);

    if (!this.isFeaturedProduct) {
      this.updatePickupAvailability();
    } else {
      const sizeOption = this.options[0].toLowerCase().replace(/ /g, "-");
      this.parentSection.setAttribute("data-size-option", sizeOption);
      if (sizeOption === "7-serve") {
        this.parentSection.removeAttribute("data-subscription-mode");
        this.parentSection.removeAttribute("data-selling-plan");
        this.productForm.querySelector("input[name='selling_plan']")?.remove();
        this.parentSection.querySelector("input[id='single_order']").click();
      }
    }

    this.removeErrorMessage();

    document.dispatchEvent(
      new CustomEvent("variant:changed", {
        detail: {
          variant: this.currentVariant,
          options: this.options,
        },
      })
    );

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;

    if (this.isFeaturedProduct) {
      newMedia.scrollIntoView({ behavior: "smooth", block: "nearest" });
    } else {
      if (window.innerWidth < 750) {
        // newMedia.scrollIntoView({behavior: "smooth", block: "center"});
      } else {
        const target = document.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        if (target) window?.carousel?.selectCell(target);
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const productInfoRendered = new CustomEvent("product-info-rendered");
        document.dispatchEvent(productInfoRendered);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const isSteppedExperience = productForm.classList.contains("form--stepped-exp");
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (isSteppedExperience) {
        addButtonText.textContent = "Unavailable";
      } else {
        if (text) addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute("disabled");
      if (isSteppedExperience) {
        addButtonText.textContent = "Checkout";
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantSelectsStepped extends VariantSelects {
  static observedAttributes = ["data-purchase-type", "data-single-sub-boxes"];
  constructor() {
    super();
    this.parentForm = this.closest("product-form");
    this.servingSize = this.parentForm.querySelector('input[name="options[Size]"]').value;
    this.sellingPlan = this.parentForm.querySelector("select.dropdown__delivery").value;
    this.purchaseType = this.dataset.purchaseType;
    this.addAnotherBox = this.querySelector("[data-add-box]");
    this.addAnotherBox.addEventListener("click", this.handleAddingAnotherBox.bind(this));
    // Remove the event listener from the parent class
    this.removeEventListener("change", this.onVariantChange);
    // Remove options that have no variants
    this.removeOptionsWithoutVariants();

    const selects = this.querySelectorAll("select");
    selects.forEach((select) => {
      select.addEventListener("change", this.onSelectChange.bind(this));
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-purchase-type") {
      this.purchaseType = newValue;
    }
    this.updateAggregateOptions();
  }

  removeOptionsWithoutVariants() {
    const flavourOptions = this.querySelectorAll("[data-content-type='Flavour']");
    const optionsJson = this.closest("add-to-cart-exp").querySelector("[data-product-json]")?.textContent;
    if (!optionsJson) return;
    const parsedOptions = JSON.parse(optionsJson)[0];
    if (!parsedOptions) return;
    // add 1 as in shopify options are not 0 indexed
    const sizeOptKey = `option${parsedOptions.options.indexOf("Size") + 1}`;
    const flavourOptKey = `option${parsedOptions.options.indexOf("Flavour") + 1}`;
    // Filter out non 30Serve variants
    const size30ServeVariants = parsedOptions.variants.filter((variant) => variant[sizeOptKey] === "30 Serve");
    flavourOptions.forEach((option) => {
      const selectOptions = option.querySelectorAll("select option");
      const fauxSelectOptions = option.querySelectorAll("faux-select li");
      selectOptions.forEach((option) => {
        const optionValue = option.value;
        const hasVariant = size30ServeVariants.some((variant) => variant[flavourOptKey] === optionValue);
        if (!hasVariant) {
          option.remove();
        }
      });
      fauxSelectOptions.forEach((option) => {
        const optionValue = option.dataset.value;
        const hasVariant = size30ServeVariants.some((variant) => variant[flavourOptKey] === optionValue);
        if (!hasVariant) {
          option.remove();
        }
      });
    });
  }

  updateAggregateOptions() {
    // Find all visible selectElement parents that aren't product plan delivery
    const products = [];
    const flavourSelects = [
      ...this.parentForm.querySelectorAll(".product-form__input--dropdown:not(.dropdown__delivery)"),
    ].filter((s) => s.offsetHeight > 0);

    flavourSelects.forEach((select) => {
      const selectValue = select.querySelector("select").value;
      const optsArray = [this.servingSize, selectValue];
      const variant = this.getVariantMatch(optsArray);
      const seling_plan = this.purchaseType === "one_time" ? null : this.sellingPlan;
      const item = {
        id: variant.id,
        quantity: 1,
        ...(seling_plan && { selling_plan: seling_plan }),
      };
      const existingItem = products.find((product) => product.id === variant.id);

      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        products.push(item);
      }
    });

    window.steppedAddToCartProducts = products;
  }

  onSelectChange(evt) {
    const currentBoxOption = evt.target.value;
    const currentFauxSelect = evt.target.closest(".select").previousElementSibling;
    const optionsArray = [this.servingSize, currentBoxOption];

    if (currentFauxSelect.classList.contains("selling_plan")) {
      // when selling plan is interacted with, update the relevant opt, and return
      this.sellingPlan = evt.target.value;
      this.updateAggregateOptions();
      // console.log("returning...", currentFauxSelect, evt.target.value);
      return;
    }

    this.updateAggregateOptions();

    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();

    const currentVariant = this.getVariantMatch(optionsArray);

    // Current variant is available
    if (currentVariant && currentVariant.available) {
      this.toggleAddButton(false, "Checkout", true);
      this.enableOptions();
    } else {
      this.toggleAddButton(true, "Not available", true);
      this.setUnavailable();
      this.disableOtherOptions(currentFauxSelect);
    }
  }

  handleAddingAnotherBox(evt) {
    evt.preventDefault();
    // Max 3 Single Boxes
    if (parseInt(this.dataset.singleSubBoxes) >= 2) {
      this.addAnotherBox.classList.add("hidden");
    }
    this.dataset.singleSubBoxes = parseInt(this.dataset.singleSubBoxes) + 1;
    this.updateAggregateOptions();
    const event = new CustomEvent("single_box_added");
    document.dispatchEvent(event);
  }

  disableOtherOptions(fauxSelectException) {
    const fauxSelects = this.querySelectorAll("faux-select");
    fauxSelects.forEach((fauxSelect) => {
      if (fauxSelect !== fauxSelectException) {
        fauxSelect.classList.add("disabled");
      }
    });
  }

  enableOptions() {
    const fauxSelects = this.querySelectorAll("faux-select");
    fauxSelects.forEach((fauxSelect) => {
      fauxSelect.classList.remove("disabled");
    });
  }

  getVariantMatch(optionsArray) {
    return this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return optionsArray[index] === option;
        })
        .includes(false);
    });
  }
}
customElements.define("variant-selects-stepped", VariantSelectsStepped);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener("click", this.openSelector.bind(this));
    this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (this.elements.button.getAttribute("aria-expanded") === "false").toString()
    );
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

class TextRotator extends HTMLElement {
  constructor() {
    super();
    this.words = [
      this.getAttribute("data-word-1"),
      this.getAttribute("data-word-2"),
      this.getAttribute("data-word-3"),
      this.getAttribute("data-word-4"),
      this.getAttribute("data-word-5"),
    ];
    this.speed = this.getAttribute("data-speed");
    this.rotateText(1);
  }

  rotateText(i) {
    if (i < this.words.length && this.words[i] !== null) {
      setTimeout(() => {
        this.innerHTML = this.words[i];
        i++;
        this.rotateText(i);
      }, parseInt(this.speed));
    } else {
      this.rotateText(0);
    }
  }
}

customElements.define("text-rotator", TextRotator);

class productVideo extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
    this.videoElem = this.querySelector("video");
    this.button.addEventListener("click", this.handlePlayButton.bind(this));
    this.videoElem.onended = () => setTimeout(this.classList.remove("playing"), 0.3);
  }

  async playVideo() {
    try {
      await this.videoElem.play();
      this.classList.add("playing");
    } catch (err) {
      this.classList.remove("playing");
    }
  }

  handlePlayButton() {
    if (this.videoElem.paused) {
      this.playVideo();
    } else {
      this.videoElem.pause();
      this.classList.remove("playing");
    }
  }
}

customElements.define("product-video", productVideo);

function blockLink() {
  const links = document.querySelectorAll(".blockLink");

  [...links].forEach((link) => {
    link.addEventListener("click", (e) => {
      const url = e.currentTarget.dataset.link;
      if (url) {
        window.location = e.currentTarget.dataset.link;
      }
    });
  });
}

blockLink();

function handleSubscriptionClick(e, index) {
  const productForm = document.querySelector("product-form form");
  const subsPrice = document.querySelector(".bsub-widget__plan-pricing span");
  const mainPrice = document.querySelector(".price--large");
  const subscriptionsButton = document.querySelector(
    ".bsub-widget__group + .bsub-widget__group .bsub-widget__group-header"
  );
  const subscriptionsButtonClone = document.querySelector(".subs-button-clone");
  const submitButton = document.querySelector(".product-form__submit");
  const submitEvent = new SubmitEvent("submit", { submitter: submitButton });
  const subsMode = window.location.href.indexOf("selling_plan") > -1;

  // Submit form if correct button is clicked
  if ((index === 0 && !subsMode) || (index === 2 && subsMode)) {
    productForm.dispatchEvent(submitEvent);
  }

  // Toggle to subs mode
  if (index === 1 && !subsMode) {
    mainPrice.classList.add("price--strike");
    mainPrice.insertAdjacentHTML(
      "beforeend",
      ` <span class="subs-price">${subsPrice.innerText} ${Shopify.currency.active}</span>`
    );
    e.currentTarget.style = "display: none !important";
    subscriptionsButtonClone.style = "display: block !important";
  }

  // Toggle back to one time purchase mode
  if (index === 0 && subsMode) {
    mainPrice.classList.remove("price--strike");
    document.querySelector(".subs-price").remove();
    subscriptionsButton.style = "display: block !important";
    subscriptionsButtonClone.style = "display: none !important";
  }
}

function handleSubscription() {
  const bsubWidget = document.querySelector(".bsub-widget");
  const addToCartButton = document.querySelector(".product-form__buttons");
  const subscriptionsButton = document.querySelector(
    ".bsub-widget__group + .bsub-widget__group .bsub-widget__group-header"
  );
  const subscriptionsButtonClone = subscriptionsButton?.cloneNode(true);
  const plansContainer = document.querySelector(".bsub-widget__plans-container");

  if (!bsubWidget) return;

  // Hide existing add to cart button
  addToCartButton.style = "display:none";

  // Clone the subscriptions button so we can place it under the options when they are visible
  subscriptionsButtonClone.classList.add("subs-button-clone");
  plansContainer.insertAdjacentElement("afterend", subscriptionsButtonClone);

  // If the options are visible initally show the cloned button and hide the default button
  if (window.getComputedStyle(plansContainer).display === "block") {
    console.log(Shopify.currency.active);
    subscriptionsButton.style = "display: none !important";
    setTimeout(() => {
      document.querySelector(".price--large").classList.add("price--strike");
      document
        .querySelector(".price--large")
        .insertAdjacentHTML(
          "beforeend",
          `<span class="subs-price">${document.querySelector(".bsub-widget__plan-pricing span").innerText} ${
            Shopify.currency.active
          }</span>`
        );
    }, 100);
  } else {
    subscriptionsButtonClone.style = "background-color: pink !important; display: none !important";
  }

  document.querySelectorAll(".bsub-widget .bsub-widget__group-header").forEach((button, index) => {
    button.addEventListener("click", (e) => handleSubscriptionClick(e, index));
  });

  // Add some extra content
  bsubWidget.insertAdjacentHTML(
    "afterend",
    `<div class="bsub-widget-callouts"><span>You&rsquo;re in control</span><span>15% Discount</span><span>Never run out!</span></div>`
  );
}

handleSubscription();

// Handle Shopify-video custom play button
const customVideoEls = document.querySelectorAll(".shopify-video[data-custom-controls]");

customVideoEls.forEach((videoEl) => {
  const playPauseButton = videoEl.querySelector("[data-play-pause]");
  const video = videoEl.querySelector("video");
  playPauseButton.addEventListener("click", () => {
    if (video.paused) {
      video.play();
      videoEl.classList.add("is-playing");
    } else {
      video.pause();
      videoEl.classList.remove("is-playing");
    }
  });
});

// Countdown Timer
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.initCountdownTimer(this);
  }

  connectedCallback() {
    this.initCountdownTimer(this);
  }

  initCountdownTimer(countdownTimer) {
    const updateCountownTimer = () => {
      const endTime = countdownTimer.dataset.countdownEnd || new Date().toString();
      const includeLeadingZero = countdownTimer.dataset.leadingZero === "true";
      const endTimeMessage = countdownTimer.dataset.countdownEndMessage || "Promotion has ended.";
      const divider = countdownTimer.dataset.divider || null;
      const dividerMarkup = divider
        ? `<div class="countdown-timer__block countdown-timer__block--divider">${divider}</div>`
        : "";
      const endTimeInSeconds = new Date(endTime).valueOf();
      const now = new Date().valueOf();
      const remainingTime = endTimeInSeconds - now;
      const formatValue = (value) => (includeLeadingZero ? (value < 10 ? `0${value}` : value) : value);
      const { days, hours, minutes, seconds } = this.getTimeRemaining(endTime);
      const template = `
        <div class="countdown-timer__timer">
          <div class="countdown-timer__block">
            <div class="countdown-timer__value">${formatValue(days)}</div>
            <div class="countdown-timer__unit">Days</div>
          </div>
          ${dividerMarkup}
          <div class="countdown-timer__block">
            <div class="countdown-timer__value">${formatValue(hours)}</div>
            <div class="countdown-timer__unit">Hrs</div>
          </div>
          ${dividerMarkup}
          <div class="countdown-timer__block">
            <div class="countdown-timer__value">${formatValue(minutes)}</div>
            <div class="countdown-timer__unit">Mins</div>
          </div>
          ${dividerMarkup}
          <div class="countdown-timer__block">
            <div class="countdown-timer__value">${formatValue(seconds)}</div>
            <div class="countdown-timer__unit">Secs</div>
          </div>
        </div>
        `;
      if (remainingTime > 1000) {
        countdownTimer.innerHTML = template;
        requestAnimationFrame(updateCountownTimer);
      } else {
        countdownTimer.innerHTML = endTimeMessage;
      }
    };

    if (countdownTimer) {
      requestAnimationFrame(updateCountownTimer);
    }
  }

  getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date().toString());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    return { days, hours, minutes, seconds };
  }
}

customElements.define("countdown-timer", CountdownTimer);

class CustomRechargeWidget extends HTMLElement {
  constructor() {
    super();
    this.parentSection = this.closest(".shopify-section");
    this.singleOrPlanRadios = this.querySelectorAll("input[name='single_or_subscription']");
    this.sellingPlanRadios = this.querySelectorAll("input[name='selling_plan_id']");
    this.productData = JSON.parse(this.querySelector("[data-product-json]").innerText);
    this.productForm = this.parentSection.querySelector("product-form");
    this.subscriptionVariants = this.productData[0].product.variants.filter(
      (variant) => variant.selling_plan_allocations.length > 0
    );
    this.singleOrPlanRadios.forEach((radio) => {
      radio.addEventListener("change", this.handlePlanChange.bind(this));
    });
    this.sellingPlanRadios.forEach((radio) => {
      radio.addEventListener("change", this.handleSellingPlanChange.bind(this));
    });
  }

  handlePlanChange(event) {
    if (event.target.value === "recurring") {
      const sellingPlanInput = document.createElement("input");
      const injectAfterTarget = this.productForm.querySelector("input[name='id']");
      sellingPlanInput.setAttribute("type", "hidden");
      sellingPlanInput.setAttribute("name", "selling_plan");
      this.parentSection.setAttribute("data-subscription-mode", "true");
      const selectedPlanRadio = [...this.sellingPlanRadios].find((radio) => radio.checked);
      this.parentSection.setAttribute("data-selling-plan", selectedPlanRadio.value);
      sellingPlanInput.setAttribute("value", selectedPlanRadio.value);
      injectAfterTarget.insertAdjacentElement("afterend", sellingPlanInput);
    } else {
      this.parentSection.removeAttribute("data-subscription-mode");
      this.parentSection.removeAttribute("data-selling-plan");
      this.productForm.querySelector("input[name='selling_plan']")?.remove();
    }
  }

  handleSellingPlanChange(event) {
    this.parentSection.setAttribute("data-selling-plan", event.target.value);
    this.productForm.querySelector("input[name='selling_plan']").setAttribute("value", event.target.value);
  }
}

customElements.define("custom-recharge-widget", CustomRechargeWidget);

class FeaturedProductMediaGallery {
  constructor(element) {
    this.featuredMediaGallery = element;
    this.featuredMediaDots = this.featuredMediaGallery.querySelectorAll(".product__media-dot");
    this.featuredMediaArrows = this.featuredMediaGallery.querySelectorAll(".product__media-arrow");
    this.featuredMediaItems = this.featuredMediaGallery.querySelectorAll(".product__media-item");
    this.attachEvents();
  }

  attachEvents() {
    this.featuredMediaDots.forEach((dot, index) => {
      dot.addEventListener("click", (event) => this.handleDotClick(event, index));
    });
    this.featuredMediaArrows.forEach((arrow) => {
      arrow.addEventListener("click", (event) => this.handleArrowClick(event, arrow.dataset.direction));
    });
    this.featuredMediaGallery.addEventListener("scroll", (event) => this.handleScroll(event));
  }

  handleDotClick(event, index) {
    const activeDot = this.featuredMediaGallery.querySelector(".product__media-dot.is-active");
    activeDot.classList.remove("is-active");
    event.target.classList.add("is-active");
    this.featuredMediaGallery.scrollTo({
      left: index * this.featuredMediaGallery.clientWidth,
      behavior: "smooth",
    });
  }

  handleArrowClick(event, direction) {
    const activeDot = this.featuredMediaGallery.querySelector(".product__media-dot.is-active");
    const activeDotIndex = [...this.featuredMediaDots].indexOf(activeDot);
    this.featuredMediaGallery.scrollTo({
      left:
        direction === "next"
          ? (activeDotIndex + 1) * this.featuredMediaGallery.clientWidth
          : (activeDotIndex - 1) * this.featuredMediaGallery.clientWidth,
      behavior: "smooth",
    });
  }

  handleScroll() {
    const { scrollLeft, clientWidth } = this.featuredMediaGallery;
    const activeDotIndex = Math.round(scrollLeft / clientWidth);
    this.featuredMediaDots.forEach((dot, index) => {
      dot.classList.remove("is-active");
      dot.classList.toggle("is-active", index === activeDotIndex);
    });

    if (activeDotIndex === this.featuredMediaItems.length - 1) {
      this.featuredMediaArrows[1].disabled = true;
    } else {
      this.featuredMediaArrows[1].disabled = false;
    }

    if (activeDotIndex === 0) {
      this.featuredMediaArrows[0].disabled = true;
    } else {
      this.featuredMediaArrows[0].disabled = false;
    }
  }
}

const featuredProductMediaGallery = document.querySelector("[data-featured-media-gallery]");
if (featuredProductMediaGallery) {
  new FeaturedProductMediaGallery(featuredProductMediaGallery);
}

class MultipacksBlock extends HTMLElement {
  constructor() {
    super();
    this.productParent = document.querySelector(".product-section .product");
    this.sellingPlanInput = this.productParent.querySelector("input[name='selling_plan']");
    this.quantityInput = this.productParent.querySelector(".product-form__buttons .quantity__input");
    this.variantsData = JSON.parse(document.querySelector("[data-variants-json]").innerText);
    this.thirtyServeVariants = this.variantsData.filter((variant) => variant.title.includes("30 Serve"));
    this.attachEvents();
  }

  showMultipacks() {
    this.style.display = "block";
    this.productParent.setAttribute("data-multipacks-enabled", "true");
  }

  hideMultipacks() {
    this.style.display = "none";
    this.productParent.removeAttribute("data-multipacks-enabled");
    this.querySelector(".multiple-packs-block__trigger[data-qty='1']").click();
    this.quantityInput.value = 1;
  }

  attachEvents() {
    this.productParent = document.querySelector(".product-section .product");
    this.sellingPlanInput = this.productParent.querySelector("input[name='selling_plan']");
    this.quantityInput = this.productParent.querySelector(".product-form__buttons .quantity__input");
    this.variantInput = this.productParent.querySelector("input[name='id']");

    if (this.sellingPlanInput.value === "") {
      this.showMultipacks();
    } else {
      this.hideMultipacks();
    }

    document.addEventListener("selling-plan-changed", (event) => {
      const sellingPlanValue = Number(event.detail.sellingPlan);
      if (sellingPlanValue === "" || sellingPlanValue === 0) {
        const selectedVariantId = Number(this.variantInput.value);
        const selectedVariant = this.thirtyServeVariants.find((variant) => variant.id === selectedVariantId);
        if (selectedVariant !== undefined) {
          this.showMultipacks();
        } else {
          this.hideMultipacks();
        }
      } else {
        this.hideMultipacks();
      }
    });

    document.addEventListener("variant:changed", (event) => {
      const selectedVariantId = event.detail.variant.id;
      const selectedVariant = this.thirtyServeVariants.find((variant) => variant.id === selectedVariantId);
      if (selectedVariant !== undefined) {
        this.showMultipacks();
      } else {
        this.hideMultipacks();
      }
    });

    this.querySelectorAll(".multiple-packs-block__trigger").forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        this.quantityInput.value = event.target.dataset.qty;
        const multipackChangedEvent = new CustomEvent("multipack-changed", {
          detail: {
            selectedMultipack: trigger,
          },
        });
        document.dispatchEvent(multipackChangedEvent);
      });
    });
  }
}

document.addEventListener("recharge-ready", () => {
  // Event defined in product-form.js, this lets us know when Recharge is ready
  customElements.define("multipacks-block", MultipacksBlock);

  const sellingPlans = document.querySelector("[data-selling-plans]")
    ? JSON.parse(document.querySelector("[data-selling-plans]").innerText).flat()
    : null;

  // Update the price
  // Check if selling_plan is defined
  const variantsData = JSON.parse(document.querySelector("[data-variants-json]").innerText);
  const sellingPlanInput = document.querySelector("input[name='selling_plan']");
  const sellingPlanValue = Number(sellingPlanInput.value);
  const variantInputEl = document.querySelector(".product__info-container input[name='id']");
  const selectedVariant = variantInputEl.value;

  const sellingPlanObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "value") {
        const event = new CustomEvent("selling-plan-changed", {
          detail: {
            sellingPlan: mutation.target.value,
          },
        });
        const selectedVariant = variantInputEl.value;
        updatePrices({ planId: mutation.target.value, selectedVariant });
        document.dispatchEvent(event);
      }
    });
  });

  sellingPlanObserver.observe(sellingPlanInput, {
    attributes: true,
    attributeFilter: ["value"],
  });

  document.addEventListener("product-info-rendered", (event) => {
    const variantInputEl = document.querySelector(".product__info-container input[name='id']");
    const selectedVariant = variantInputEl.value;
    const sellingPlanInput = document.querySelector("input[name='selling_plan']");
    const sellingPlanValue = Number(sellingPlanInput.value);
    updatePrices({ selectedVariant, planId: sellingPlanValue });
  });

  document.addEventListener("multipack-changed", (event) => {
    const variantInputEl = document.querySelector(".product__info-container input[name='id']");
    const selectedVariant = variantInputEl.value;
    const sellingPlanInput = document.querySelector("input[name='selling_plan']");
    const sellingPlanValue = Number(sellingPlanInput.value);
    updatePrices({ selectedVariant, planId: sellingPlanValue, selectedMultipack: event.detail.selectedMultipack });
  });

  function updatePrices({ planId, selectedVariant, selectedMultipack }) {
    if (!sellingPlans) return;
    const sellingPlan = sellingPlans.find((plan) => plan.id === Number(planId));

    const singlePrice = Shopify.formatMoney(
      variantsData.find((variant) => variant.id === Number(selectedVariant))["price"]
    );
    const priceElement = document.querySelector(".price__regular .price-item--regular");
    const compareAtPrice = document.querySelector(".product__info-container .subscription_com_price");

    if (planId === "" || planId === 0) {
      // A one-off purchase
      const multipacksBlock = document.querySelector("multipacks-block");
      if (multipacksBlock && multipacksBlock.checkVisibility()) {
        // need to discount final price
        compareAtPrice.innerHTML = `${singlePrice}`;
        const singlePriceNumber = Number(singlePrice.replace("$", "").replace(",", ""));
        const discount = Number(selectedMultipack.dataset.discount);
        const discountPercentage = discount / 100;
        const discountedPrice = parseFloat(singlePriceNumber - discountPercentage * singlePriceNumber).toFixed(2);
        if (discountPercentage === 0) {
          compareAtPrice.innerHTML = "";
          priceElement.innerHTML = `${singlePrice}`;
        } else {
          priceElement.innerHTML = `${Shopify.formatMoney(discountedPrice)}`;
        }
      } else {
        compareAtPrice.innerHTML = "";
        priceElement.innerHTML = `${singlePrice}`;
      }
    } else {
      const priceAdjustment = sellingPlan.price_adjustments[0].value;
      const priceAdjustmentPercentage = priceAdjustment / 100;
      const singlePriceNumber = Number(singlePrice.replace("$", "").replace(",", ""));
      const subscriptionPrice = parseFloat(singlePriceNumber - priceAdjustmentPercentage * singlePriceNumber).toFixed(
        2
      );
      // update prices to subscription
      priceElement.innerHTML = `${Shopify.formatMoney(subscriptionPrice)}`;
      compareAtPrice.innerHTML = `${singlePrice}`;
    }
  }
});

const domReady = () => {
  const productAccordions = document.querySelectorAll(".product .product__accordion details");
  productAccordions.forEach((accordion) => {
    accordion.addEventListener("click", () => {
      productAccordions.forEach((el) => {
        if (accordion === el) return;
        el.removeAttribute("open");
      });
    });
  });

  document.documentElement.style.setProperty(
    "--scrollbar-width",
    window.innerWidth - document.documentElement.clientWidth + "px"
  );
};

document.addEventListener("DOMContentLoaded", domReady);


// CD Code
setTimeout(() => {
  const widget = document.querySelector('recharge-subscription-widget');

  if (widget?.shadowRoot) {
    const radio = widget.shadowRoot.querySelector(
      'input[type="radio"]:checked'
    );

    if (radio) {
      // force re-trigger
      radio.dispatchEvent(new Event('click', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}, 2500);

